import React, { FC } from 'react';

export const CircleArrowDown: FC = (props) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="12" cy="12" r="12" fill="#02315B" />
    <path
      d="M17.442 9a.492.492 0 0 0-.38.23L12 15.186 6.935 9.23a.577.577 0 0 0-.178-.169.42.42 0 0 0-.212-.059.447.447 0 0 0-.304.128.754.754 0 0 0-.2.341c-.042.139-.052.291-.03.438.023.146.076.28.154.384l5.449 6.486c.102.14.24.22.385.22.144 0 .283-.08.385-.22l5.449-6.486a.863.863 0 0 0 .156-.389 1.022 1.022 0 0 0-.03-.442.746.746 0 0 0-.207-.342.441.441 0 0 0-.31-.12Z"
      fill="#fff"
      stroke="#fff"
    />
  </svg>
);
